<template lang="pug">
    div
        template(v-if="item.photo && item.photo.path")
            img.user-avatar.border.rounded-full.object-cover.cursor-pointer(
                :src="photoUrl"
                crossorigin="use-credentials"
                @click="() => { if (isActive) onImage({name: `${item._id}-photo`}) }"
            )
        template(v-else)
            .user-avatar.border.rounded-full.bg-main.cursor-pointer(@click="() => { if (isActive) onImage({name: `${item._id}-photo`}) }")
        modal(:name="`${item._id}-photo`")
            .p-5
                drag-n-drop-files.mb-3(@files="photo = $event")
                regular-button.w-32(:value="BUTTONS_VALUES.save" :loading="saving" @click="onImageChange({ id: item._id, modal_name: `${item._id}-photo` })")
</template>

<script>
//Components
import ChooseFile from '@/components/common/forms/choose-file';
import RegularButton from '@/components/common/buttons/regular-button';
import DragNDropFiles from '@/components/common/forms/drag-n-drop-files';
//Configs
import { BUTTONS_VALUES, FORMS_LABELS } from '@/configs/names.js';
//Mixins
import { _openModal_, _closeModal_ } from '@/mixins/modals';
import { _onFileUpload_ } from '@/mixins/files';
//Store
import { UsersNameSpace, UsersActionTypes } from '@/store/users/types';

export default {
    name: "DefaultUserImage",
    components: {
        'choose-file': ChooseFile,
        'regular-button': RegularButton,
        'drag-n-drop-files': DragNDropFiles,
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        isActive: {
            type: Boolean,
            default: true,
        }
    },
    mixins: [_openModal_, _closeModal_, _onFileUpload_],
    data() {
        return {
            photo: '',
            saving: false,
        }
    },
    computed: {
        base_url() {
            return process.env.VUE_APP_BASE_URL
        },
        photoUrl() {
            const photo = this.item.photo || {}
            const path = photo.sm_path || photo.path
            if (!path) {
                return ''
            }
            if (/^https?:\/\//.test(path)) {
                return path
            }
            return `${this.base_url}/${String(path).replace(/^\.\//, '')}`
        },
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        FORMS_LABELS() {
            return FORMS_LABELS
        },
    },
    methods: {
        isValidHttpUrl(string) {
            let url;
            
            try {
                url = new URL(string);
            } catch (_) {
                return false;  
            }

            return url.protocol === "http:" || url.protocol === "https:";
        },
        onImage({ name }) {
            this._openModal_({ name })
        },
        async onImageChange({ id, modal_name }) {
            if (this.saving) {
                return
            }
            this.saving = true
            try {
                await this._onFileUpload_({ field: 'photo' })
                await this.onUserChange({ id: id, value: { photo: this._loadedFile_._id  } })
                this.$emit('updated')
                this._closeModal_({ name: modal_name })
            } finally {
                this.saving = false
            }
        },
        async onUserChange({ id, value }) {
            await this.$store.dispatch(`${UsersNameSpace}/${UsersActionTypes.EditUser}`, { id, value })
        },
    }
}
</script>

<style lang="scss" scoped>
.user-avatar {
    width: 64px;
    height: 64px;
    min-width: 64px;
    min-height: 64px;
    max-width: none;
    flex-shrink: 0;
}
</style>